import hoverIntent from '../../libs/hoverIntent';

/**
 * Megadrop
 * Functions for the megadrop.
 * @version 3.0.0
 * @exports Megadrop
 */
export default class Megadrop {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		!Modernizr.touchevents ? this._initHoverIntent() : this._initTouchHover();

		this._initKeyboardNavigation();
	}

	/**
	 * Add megadrop hover function with the hoverIntent plugin.
	 * @private
	 */
	_initHoverIntent() {
		let els = document.querySelectorAll('.has-megadrop');
		let menuParentElement = document.getElementById('menu');
		var element = document.getElementById('overlay__page-cover');
		els.forEach(el => {
			hoverIntent(
				el,
				function() {
					this.classList.add('megadrop--active');
					// document.body.classList.add('overlay');

					// element.classList.add('active');
				},
				function() {
					this.classList.remove('megadrop--active');
					// document.body.classList.remove('overlay');

					// element.classList.remove('active');
				}
			);
		});

		menuParentElement.addEventListener(
			'mouseenter',
			function() {
				document.body.classList.add('overlay');
				element.classList.add('active');
			},
			false
		);
		menuParentElement.addEventListener(
			'mouseleave',
			function() {
				document.body.classList.remove('overlay');
				element.classList.remove('active');
			},
			false
		);
		// Documented out this section because the menu disapears when entering next object. Making it not smooth for the eyes when the content enters and leaves.
		//document.documentElement.classList.remove('megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
	}

	/**
	 * Fixes so hover works on touch devices.
	 * @private
	 */
	_initTouchHover() {
		let els = document.querySelectorAll('.has-megadrop');

		els.forEach(el => {
			el.addEventListener('click', event => {
				if (
					!el.classList.contains('megadrop--active') ||
					(el.classList.contains('megadrop--active') &&
						event.target.tagName !== 'A')
				) {
					event.preventDefault();
				}

				let els = document.querySelectorAll('.has-megadrop');
				els.forEach(el => {
					el.classList.remove('megadrop--active');
					document.body.classList.remove('overlay');
				});

				event.target.parentNode.classList.add('megadrop--active');
				document.body.classList.add('overlay');
			});
		});

		//document.documentElement.classList.remove('megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
	}

	/**
	 * Add keyboard tab navigation to megadrop.
	 * @private
	 */
	_initKeyboardNavigation() {
		let els = document.querySelectorAll('.has-megadrop');

		els.forEach(el => {
			el.addEventListener('keydown', event => {
				if (event.keyCode === 13) {
					if (!el.classList.contains('megadrop--active')) {
						event.preventDefault();
						el.classList.add('megadrop--active');
						document.body.classList.add('overlay');
					}
				}
			});

			el.addEventListener(
				'focus',
				() => {
					if (el.getAttribute('data-focusOutTimer') !== undefined) {
						clearTimeout(el.getAttribute('data-focusOutTimer'));
					}
				},
				true
			);

			el.addEventListener(
				'blur',
				() => {
					el.setAttribute(
						'data-focusOutTimer',
						setTimeout(() => {
							el.classList.remove('megadrop--active');
							document.body.classList.remove('overlay');
						}, 50)
					);
				},
				true
			);
		});
	}
}
